<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>{{ data?.title }}</h1>
<div mat-dialog-content>
    <ng-container *ngComponentOutlet="data.component"></ng-container>
</div>
<!-- <div mat-dialog-actions>
    <div>
        <button mat-button mat-dialog-close class="btn">Chiudi</button>
    </div>
</div> -->